(function () {

/*!
* CookieConsent 3.0.0-rc.15
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/ const $47b1592ab1581a62$var$e = "opt-in", $47b1592ab1581a62$var$t = "opt-out", $47b1592ab1581a62$var$n = "show--consent", $47b1592ab1581a62$var$o = "show--preferences", $47b1592ab1581a62$var$a = "disable--interaction", $47b1592ab1581a62$var$s = "data-category", $47b1592ab1581a62$var$c = "div", $47b1592ab1581a62$var$r = "button", $47b1592ab1581a62$var$i = "aria-hidden", $47b1592ab1581a62$var$l = "btn-group", $47b1592ab1581a62$var$d = "click", $47b1592ab1581a62$var$f = "data-role", $47b1592ab1581a62$var$_ = "consentModal", $47b1592ab1581a62$var$u = "preferencesModal";
class $47b1592ab1581a62$var$p {
    constructor(){
        this.t = {
            mode: $47b1592ab1581a62$var$e,
            revision: 0,
            autoShow: !0,
            lazyHtmlGeneration: !0,
            autoClearCookies: !0,
            manageScriptTags: !0,
            hideFromBots: !0,
            cookie: {
                name: "cc_cookie",
                expiresAfterDays: 182,
                domain: "",
                path: "/",
                sameSite: "Lax"
            }
        }, this.o = {
            i: {},
            l: "",
            _: {},
            u: {},
            p: {},
            m: [],
            g: !1,
            v: null,
            h: null,
            C: null,
            S: "",
            M: !0,
            D: !1,
            T: !1,
            k: !1,
            A: !1,
            N: [],
            H: !1,
            F: !0,
            V: [],
            j: !1,
            P: "",
            I: !1,
            L: [],
            O: [],
            R: [],
            B: [],
            G: !1,
            J: !1,
            U: !1,
            $: [],
            q: [],
            K: null,
            W: [],
            X: [],
            Y: {},
            Z: {},
            ee: {},
            te: {},
            ne: {},
            oe: []
        }, this.ae = {
            se: {},
            ce: {}
        }, this.re = {}, this.ie = {
            le: "cc:onFirstConsent",
            de: "cc:onConsent",
            fe: "cc:onChange",
            _e: "cc:onModalShow",
            ue: "cc:onModalHide",
            pe: "cc:onModalReady"
        };
    }
}
const $47b1592ab1581a62$var$m = new $47b1592ab1581a62$var$p, $47b1592ab1581a62$var$g = (e, t)=>e.indexOf(t), $47b1592ab1581a62$var$b = (e, t)=>-1 !== $47b1592ab1581a62$var$g(e, t), $47b1592ab1581a62$var$v = (e)=>Array.isArray(e), $47b1592ab1581a62$var$y = (e)=>"string" == typeof e, $47b1592ab1581a62$var$h = (e)=>!!e && "object" == typeof e && !$47b1592ab1581a62$var$v(e), $47b1592ab1581a62$var$C = (e)=>"function" == typeof e, $47b1592ab1581a62$var$w = (e)=>Object.keys(e), $47b1592ab1581a62$var$S = (e)=>Array.from(new Set(e)), $47b1592ab1581a62$var$x = ()=>document.activeElement, $47b1592ab1581a62$var$M = (e)=>e.preventDefault(), $47b1592ab1581a62$var$D = (e, t)=>e.querySelectorAll(t), $47b1592ab1581a62$var$T = (e)=>e.dispatchEvent(new Event("change")), $47b1592ab1581a62$var$E = (e)=>{
    const t = document.createElement(e);
    return e === $47b1592ab1581a62$var$r && (t.type = e), t;
}, $47b1592ab1581a62$var$k = (e, t, n)=>e.setAttribute(t, n), $47b1592ab1581a62$var$A = (e, t, n)=>{
    e.removeAttribute(n ? "data-" + t : t);
}, $47b1592ab1581a62$var$N = (e, t, n)=>e.getAttribute(n ? "data-" + t : t), $47b1592ab1581a62$var$H = (e, t)=>e.appendChild(t), $47b1592ab1581a62$var$F = (e, t)=>e.classList.add(t), $47b1592ab1581a62$var$V = (e, t)=>$47b1592ab1581a62$var$F(e, "cm__" + t), $47b1592ab1581a62$var$j = (e, t)=>$47b1592ab1581a62$var$F(e, "pm__" + t), $47b1592ab1581a62$var$P = (e, t)=>e.classList.remove(t), $47b1592ab1581a62$var$I = (e)=>{
    if ("object" != typeof e) return e;
    if (e instanceof Date) return new Date(e.getTime());
    let t = Array.isArray(e) ? [] : {};
    for(let n in e){
        let o = e[n];
        t[n] = $47b1592ab1581a62$var$I(o);
    }
    return t;
}, $47b1592ab1581a62$var$L = ()=>{
    const e = {}, { L: t, Y: n, Z: o } = $47b1592ab1581a62$var$m.o;
    for (const a of t)e[a] = $47b1592ab1581a62$var$G(o[a], $47b1592ab1581a62$var$w(n[a]));
    return e;
}, $47b1592ab1581a62$var$O = (e, t)=>dispatchEvent(new CustomEvent(e, {
        detail: t
    })), $47b1592ab1581a62$var$R = (e, t, n, o)=>{
    e.addEventListener(t, n), o && $47b1592ab1581a62$var$m.o.m.push({
        me: e,
        ge: t,
        be: n
    });
}, $47b1592ab1581a62$var$B = ()=>{
    const e = $47b1592ab1581a62$var$m.t.cookie.expiresAfterDays;
    return $47b1592ab1581a62$var$C(e) ? e($47b1592ab1581a62$var$m.o.P) : e;
}, $47b1592ab1581a62$var$G = (e, t)=>{
    const n = e || [], o = t || [];
    return n.filter((e)=>!$47b1592ab1581a62$var$b(o, e)).concat(o.filter((e)=>!$47b1592ab1581a62$var$b(n, e)));
}, $47b1592ab1581a62$var$J = (e)=>{
    $47b1592ab1581a62$var$m.o.O = $47b1592ab1581a62$var$S(e), $47b1592ab1581a62$var$m.o.P = (()=>{
        let e = "custom";
        const { O: t, L: n, R: o } = $47b1592ab1581a62$var$m.o, a = t.length;
        return a === n.length ? e = "all" : a === o.length && (e = "necessary"), e;
    })();
}, $47b1592ab1581a62$var$U = (e, t, n, o)=>{
    const a = "accept-", { show: s, showPreferences: c, hide: r, hidePreferences: i, acceptCategory: l } = t, f = e || document, _ = (e)=>$47b1592ab1581a62$var$D(f, `[data-cc="${e}"]`), u = (e, t)=>{
        $47b1592ab1581a62$var$M(e), l(t), i(), r();
    }, p = _("show-preferencesModal"), g = _("show-consentModal"), b = _(a + "all"), v = _(a + "necessary"), y = _(a + "custom"), h = $47b1592ab1581a62$var$m.t.lazyHtmlGeneration;
    for (const e of p)$47b1592ab1581a62$var$k(e, "aria-haspopup", "dialog"), $47b1592ab1581a62$var$R(e, $47b1592ab1581a62$var$d, (e)=>{
        $47b1592ab1581a62$var$M(e), c();
    }), h && ($47b1592ab1581a62$var$R(e, "mouseenter", (e)=>{
        $47b1592ab1581a62$var$M(e), $47b1592ab1581a62$var$m.o.A || n(t, o);
    }, !0), $47b1592ab1581a62$var$R(e, "focus", ()=>{
        $47b1592ab1581a62$var$m.o.A || n(t, o);
    }));
    for (let e of g)$47b1592ab1581a62$var$k(e, "aria-haspopup", "dialog"), $47b1592ab1581a62$var$R(e, $47b1592ab1581a62$var$d, (e)=>{
        $47b1592ab1581a62$var$M(e), s(!0);
    }, !0);
    for (let e of b)$47b1592ab1581a62$var$R(e, $47b1592ab1581a62$var$d, (e)=>{
        u(e, "all");
    }, !0);
    for (let e of y)$47b1592ab1581a62$var$R(e, $47b1592ab1581a62$var$d, (e)=>{
        u(e);
    }, !0);
    for (let e of v)$47b1592ab1581a62$var$R(e, $47b1592ab1581a62$var$d, (e)=>{
        u(e, []);
    }, !0);
}, $47b1592ab1581a62$var$$ = (e, t, n)=>{
    e && (n && (e.tabIndex = -1), e.focus()), t && ($47b1592ab1581a62$var$m.o.K = 1 === t ? $47b1592ab1581a62$var$m.ae.ve : $47b1592ab1581a62$var$m.ae.ye, $47b1592ab1581a62$var$m.o.W = 1 === t ? $47b1592ab1581a62$var$m.o.$ : $47b1592ab1581a62$var$m.o.q), n && e && e.removeAttribute("tabindex");
};
let $47b1592ab1581a62$var$z;
const $47b1592ab1581a62$var$q = (e)=>{
    clearTimeout($47b1592ab1581a62$var$z), e ? $47b1592ab1581a62$var$F($47b1592ab1581a62$var$m.ae.he, $47b1592ab1581a62$var$a) : $47b1592ab1581a62$var$z = setTimeout(()=>{
        $47b1592ab1581a62$var$P($47b1592ab1581a62$var$m.ae.he, $47b1592ab1581a62$var$a);
    }, 500);
}, $47b1592ab1581a62$var$K = [
    "M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5",
    "M 3.572 13.406 L 8.281 18.115 L 20.428 5.885",
    "M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 "
], $47b1592ab1581a62$var$Q = (e = 0, t = 1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${$47b1592ab1581a62$var$K[e]}"/></svg>`, $47b1592ab1581a62$var$W = [
    "[href]",
    $47b1592ab1581a62$var$r,
    "input",
    "details",
    "[tabindex]"
].map((e)=>e + ':not([tabindex="-1"])').join(","), $47b1592ab1581a62$var$X = (e)=>{
    const { o: t, ae: n } = $47b1592ab1581a62$var$m, o = (e, t)=>{
        const n = $47b1592ab1581a62$var$D(e, $47b1592ab1581a62$var$W);
        t[0] = n[0], t[1] = n[n.length - 1];
    };
    1 === e && t.D && o(n.Ce, t.$), 2 === e && t.A && o(n.we, t.q);
}, $47b1592ab1581a62$var$Y = (e, t, n)=>{
    const { fe: o, de: a, le: s, ue: c, pe: r, _e: i } = $47b1592ab1581a62$var$m.re, l = $47b1592ab1581a62$var$m.ie, d = {
        cookie: $47b1592ab1581a62$var$m.o.p
    };
    if (t) {
        const o = {
            modalName: t
        };
        return e === l._e ? $47b1592ab1581a62$var$C(i) && i(o) : e === l.ue ? $47b1592ab1581a62$var$C(c) && c(o) : (o.modal = n, $47b1592ab1581a62$var$C(r) && r(o)), $47b1592ab1581a62$var$O(e, o);
    }
    e === l.le ? $47b1592ab1581a62$var$C(s) && s($47b1592ab1581a62$var$I(d)) : e === l.de ? $47b1592ab1581a62$var$C(a) && a($47b1592ab1581a62$var$I(d)) : (d.changedCategories = $47b1592ab1581a62$var$m.o.V, d.changedServices = $47b1592ab1581a62$var$m.o.te, $47b1592ab1581a62$var$C(o) && o($47b1592ab1581a62$var$I(d))), $47b1592ab1581a62$var$O(e, $47b1592ab1581a62$var$I(d));
}, $47b1592ab1581a62$var$Z = (e)=>{
    const { Z: t, te: n, L: o, Y: a, oe: c, p: r, V: i } = $47b1592ab1581a62$var$m.o;
    for (const e of o){
        const o = n[e] || t[e] || [];
        for (const n of o){
            const o = a[e][n];
            if (!o) continue;
            const { onAccept: s, onReject: c } = o;
            !o.Se && $47b1592ab1581a62$var$b(t[e], n) && $47b1592ab1581a62$var$C(s) ? (o.Se = !0, s()) : o.Se && !$47b1592ab1581a62$var$b(t[e], n) && $47b1592ab1581a62$var$C(c) && (o.Se = !1, c());
        }
    }
    if (!$47b1592ab1581a62$var$m.t.manageScriptTags) return;
    const l = c, d = e || r.categories || [], f = (e, o)=>{
        if (o >= e.length) return;
        const a = c[o];
        if (a.xe) return f(e, o + 1);
        const r = a.Me, l = a.De, _ = a.Te, u = $47b1592ab1581a62$var$b(d, l), p = !!_ && $47b1592ab1581a62$var$b(t[l], _);
        if (!_ && !a.Ee && u || !_ && a.Ee && !u && $47b1592ab1581a62$var$b(i, l) || _ && !a.Ee && p || _ && a.Ee && !p && $47b1592ab1581a62$var$b(n[l] || [], _)) {
            a.xe = !0;
            const t = $47b1592ab1581a62$var$N(r, "type", !0);
            $47b1592ab1581a62$var$A(r, "type", !!t), $47b1592ab1581a62$var$A(r, $47b1592ab1581a62$var$s);
            let n = $47b1592ab1581a62$var$N(r, "src", !0);
            n && $47b1592ab1581a62$var$A(r, "src", !0);
            const c = $47b1592ab1581a62$var$E("script");
            c.textContent = r.innerHTML;
            for (const { nodeName: e } of r.attributes)$47b1592ab1581a62$var$k(c, e, r[e] || $47b1592ab1581a62$var$N(r, e));
            t && (c.type = t), n ? c.src = n : n = r.src;
            const i = !!n && (!t || [
                "text/javascript",
                "module"
            ].includes(t));
            if (i && (c.onload = c.onerror = ()=>{
                f(e, ++o);
            }), r.replaceWith(c), i) return;
        }
        f(e, ++o);
    };
    f(l, 0);
}, $47b1592ab1581a62$var$ee = "bottom", $47b1592ab1581a62$var$te = "left", $47b1592ab1581a62$var$ne = "center", $47b1592ab1581a62$var$oe = "right", $47b1592ab1581a62$var$ae = "inline", $47b1592ab1581a62$var$se = "wide", $47b1592ab1581a62$var$ce = "pm--", $47b1592ab1581a62$var$re = [
    "middle",
    "top",
    $47b1592ab1581a62$var$ee
], $47b1592ab1581a62$var$ie = [
    $47b1592ab1581a62$var$te,
    $47b1592ab1581a62$var$ne,
    $47b1592ab1581a62$var$oe
], $47b1592ab1581a62$var$le = {
    box: {
        ke: [
            $47b1592ab1581a62$var$se,
            $47b1592ab1581a62$var$ae
        ],
        Ae: $47b1592ab1581a62$var$re,
        Ne: $47b1592ab1581a62$var$ie,
        He: $47b1592ab1581a62$var$ee,
        Fe: $47b1592ab1581a62$var$oe
    },
    cloud: {
        ke: [
            $47b1592ab1581a62$var$ae
        ],
        Ae: $47b1592ab1581a62$var$re,
        Ne: $47b1592ab1581a62$var$ie,
        He: $47b1592ab1581a62$var$ee,
        Fe: $47b1592ab1581a62$var$ne
    },
    bar: {
        ke: [
            $47b1592ab1581a62$var$ae
        ],
        Ae: $47b1592ab1581a62$var$re.slice(1),
        Ne: [],
        He: $47b1592ab1581a62$var$ee,
        Fe: ""
    }
}, $47b1592ab1581a62$var$de = {
    box: {
        ke: [],
        Ae: [],
        Ne: [],
        He: "",
        Fe: ""
    },
    bar: {
        ke: [
            $47b1592ab1581a62$var$se
        ],
        Ae: [],
        Ne: [
            $47b1592ab1581a62$var$te,
            $47b1592ab1581a62$var$oe
        ],
        He: "",
        Fe: $47b1592ab1581a62$var$te
    }
}, $47b1592ab1581a62$var$fe = (e)=>{
    const t = $47b1592ab1581a62$var$m.o.i.guiOptions, n = t && t.consentModal, o = t && t.preferencesModal;
    0 === e && $47b1592ab1581a62$var$_e($47b1592ab1581a62$var$m.ae.Ce, $47b1592ab1581a62$var$le, n, "cm--", "box", "cm"), 1 === e && $47b1592ab1581a62$var$_e($47b1592ab1581a62$var$m.ae.we, $47b1592ab1581a62$var$de, o, $47b1592ab1581a62$var$ce, "box", "pm");
}, $47b1592ab1581a62$var$_e = (e, t, n, o, a, s)=>{
    e.className = s;
    const c = n && n.layout, r = n && n.position, i = n && n.flipButtons, l = !n || !1 !== n.equalWeightButtons, d = c && c.split(" ") || [], f = d[0], _ = d[1], u = f in t ? f : a, p = t[u], g = $47b1592ab1581a62$var$b(p.ke, _) && _, v = r && r.split(" ") || [], y = v[0], h = o === $47b1592ab1581a62$var$ce ? v[0] : v[1], C = $47b1592ab1581a62$var$b(p.Ae, y) ? y : p.He, w = $47b1592ab1581a62$var$b(p.Ne, h) ? h : p.Fe, S = (t)=>{
        t && $47b1592ab1581a62$var$F(e, o + t);
    };
    S(u), S(g), S(C), S(w), i && S("flip");
    const x = s + "__btn--secondary";
    if ("cm" === s) {
        const { Ve: e, je: t } = $47b1592ab1581a62$var$m.ae;
        e && (l ? $47b1592ab1581a62$var$P(e, x) : $47b1592ab1581a62$var$F(e, x)), t && (l ? $47b1592ab1581a62$var$P(t, x) : $47b1592ab1581a62$var$F(t, x));
    } else {
        const { Pe: e } = $47b1592ab1581a62$var$m.ae;
        e && (l ? $47b1592ab1581a62$var$P(e, x) : $47b1592ab1581a62$var$F(e, x));
    }
}, $47b1592ab1581a62$var$ue = (e, t)=>{
    const n = $47b1592ab1581a62$var$m.o, o = $47b1592ab1581a62$var$m.ae, { hide: a, hidePreferences: s, acceptCategory: _ } = e, p = (e)=>{
        _(e), s(), a();
    }, g = n.u && n.u.preferencesModal;
    if (!g) return;
    const b = g.title, v = g.closeIconLabel, C = g.acceptAllBtn, S = g.acceptNecessaryBtn, x = g.savePreferencesBtn, M = g.sections, D = C || S || x;
    if (o.ye) o.Ie = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$j(o.Ie, "body");
    else {
        o.ye = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$F(o.ye, "pm-wrapper"), o.ye.tabIndex = -1;
        const e = $47b1592ab1581a62$var$E("div");
        $47b1592ab1581a62$var$F(e, "pm-overlay"), $47b1592ab1581a62$var$H(o.ye, e), $47b1592ab1581a62$var$R(e, $47b1592ab1581a62$var$d, s), o.we = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.we.style.visibility = "hidden", $47b1592ab1581a62$var$F(o.we, "pm"), $47b1592ab1581a62$var$k(o.we, "role", "dialog"), $47b1592ab1581a62$var$k(o.we, $47b1592ab1581a62$var$i, !0), $47b1592ab1581a62$var$k(o.we, "aria-modal", !0), $47b1592ab1581a62$var$k(o.we, "aria-labelledby", "pm__title"), $47b1592ab1581a62$var$R(o.he, "keydown", (e)=>{
            27 === e.keyCode && s();
        }, !0), o.Le = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$j(o.Le, "header"), o.Oe = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$j(o.Oe, "title"), o.Oe.id = "pm__title", $47b1592ab1581a62$var$k(o.Oe, "role", "heading"), $47b1592ab1581a62$var$k(o.Oe, "aria-level", "2"), o.Re = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$j(o.Re, "close-btn"), $47b1592ab1581a62$var$k(o.Re, "aria-label", g.closeIconLabel || ""), $47b1592ab1581a62$var$R(o.Re, $47b1592ab1581a62$var$d, s), o.Be = $47b1592ab1581a62$var$E("span"), o.Be.innerHTML = $47b1592ab1581a62$var$Q(), $47b1592ab1581a62$var$H(o.Re, o.Be), o.Ge = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$j(o.Ge, "body"), o.Je = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$j(o.Je, "footer");
        var T = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
        $47b1592ab1581a62$var$F(T, "btns");
        var A = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), N = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
        $47b1592ab1581a62$var$j(A, $47b1592ab1581a62$var$l), $47b1592ab1581a62$var$j(N, $47b1592ab1581a62$var$l), $47b1592ab1581a62$var$H(o.Je, A), $47b1592ab1581a62$var$H(o.Je, N), $47b1592ab1581a62$var$H(o.Le, o.Oe), $47b1592ab1581a62$var$H(o.Le, o.Re), $47b1592ab1581a62$var$H(o.we, o.Le), $47b1592ab1581a62$var$H(o.we, o.Ge), D && $47b1592ab1581a62$var$H(o.we, o.Je), $47b1592ab1581a62$var$H(o.ye, o.we);
    }
    let V;
    b && (o.Oe.innerHTML = b, v && $47b1592ab1581a62$var$k(o.Re, "aria-label", v)), M && M.forEach((e, t)=>{
        const a = e.title, s = e.description, l = e.linkedCategory, f = l && n.I[l], _ = e.cookieTable, u = _ && _.body, p = _ && _.caption, m = u && u.length > 0, b = !!f, v = b && n.Y[l], C = $47b1592ab1581a62$var$h(v) && $47b1592ab1581a62$var$w(v) || [], S = b && (!!s || !!m || $47b1592ab1581a62$var$w(v).length > 0);
        var x = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
        if ($47b1592ab1581a62$var$j(x, "section"), S || s) {
            var M = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
            $47b1592ab1581a62$var$j(M, "section-desc-wrapper");
        }
        let D = C.length;
        if (S && D > 0) {
            const e = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
            $47b1592ab1581a62$var$j(e, "section-services");
            for (const t of C){
                const n = v[t], o = n && n.label || t, a = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), s = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), r = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), i = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
                $47b1592ab1581a62$var$j(a, "service"), $47b1592ab1581a62$var$j(i, "service-title"), $47b1592ab1581a62$var$j(s, "service-header"), $47b1592ab1581a62$var$j(r, "service-icon");
                const d = $47b1592ab1581a62$var$pe(o, t, f, !0, l);
                i.innerHTML = o, $47b1592ab1581a62$var$H(s, r), $47b1592ab1581a62$var$H(s, i), $47b1592ab1581a62$var$H(a, s), $47b1592ab1581a62$var$H(a, d), $47b1592ab1581a62$var$H(e, a);
            }
            $47b1592ab1581a62$var$H(M, e);
        }
        if (a) {
            var T = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), A = $47b1592ab1581a62$var$E(b ? $47b1592ab1581a62$var$r : $47b1592ab1581a62$var$c);
            if ($47b1592ab1581a62$var$j(T, "section-title-wrapper"), $47b1592ab1581a62$var$j(A, "section-title"), A.innerHTML = a, $47b1592ab1581a62$var$H(T, A), b) {
                const e = $47b1592ab1581a62$var$E("span");
                e.innerHTML = $47b1592ab1581a62$var$Q(2, 3.5), $47b1592ab1581a62$var$j(e, "section-arrow"), $47b1592ab1581a62$var$H(T, e), x.className += "--toggle";
                const t = $47b1592ab1581a62$var$pe(a, l, f);
                let n = g.serviceCounterLabel;
                if (D > 0 && $47b1592ab1581a62$var$y(n)) {
                    let e = $47b1592ab1581a62$var$E("span");
                    $47b1592ab1581a62$var$j(e, "badge"), $47b1592ab1581a62$var$j(e, "service-counter"), $47b1592ab1581a62$var$k(e, $47b1592ab1581a62$var$i, !0), $47b1592ab1581a62$var$k(e, "data-servicecounter", D), n && (n = n.split("|"), n = n.length > 1 && D > 1 ? n[1] : n[0], $47b1592ab1581a62$var$k(e, "data-counterlabel", n)), e.innerHTML = D + (n ? " " + n : ""), $47b1592ab1581a62$var$H(A, e);
                }
                if (S) {
                    $47b1592ab1581a62$var$j(x, "section--expandable");
                    var N = l + "-desc";
                    $47b1592ab1581a62$var$k(A, "aria-expanded", !1), $47b1592ab1581a62$var$k(A, "aria-controls", N);
                }
                $47b1592ab1581a62$var$H(T, t);
            } else $47b1592ab1581a62$var$k(A, "role", "heading"), $47b1592ab1581a62$var$k(A, "aria-level", "3");
            $47b1592ab1581a62$var$H(x, T);
        }
        if (s) {
            var I = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
            $47b1592ab1581a62$var$j(I, "section-desc"), I.innerHTML = s, $47b1592ab1581a62$var$H(M, I);
        }
        if (S && ($47b1592ab1581a62$var$k(M, $47b1592ab1581a62$var$i, "true"), M.id = N, ((e, t, n)=>{
            $47b1592ab1581a62$var$R(A, $47b1592ab1581a62$var$d, ()=>{
                t.classList.contains("is-expanded") ? ($47b1592ab1581a62$var$P(t, "is-expanded"), $47b1592ab1581a62$var$k(n, "aria-expanded", "false"), $47b1592ab1581a62$var$k(e, $47b1592ab1581a62$var$i, "true")) : ($47b1592ab1581a62$var$F(t, "is-expanded"), $47b1592ab1581a62$var$k(n, "aria-expanded", "true"), $47b1592ab1581a62$var$k(e, $47b1592ab1581a62$var$i, "false"));
            });
        })(M, x, A), m)) {
            const e = $47b1592ab1581a62$var$E("table"), n = $47b1592ab1581a62$var$E("thead"), a = $47b1592ab1581a62$var$E("tbody");
            if (p) {
                const t = $47b1592ab1581a62$var$E("caption");
                $47b1592ab1581a62$var$j(t, "table-caption"), t.innerHTML = p, e.appendChild(t);
            }
            $47b1592ab1581a62$var$j(e, "section-table"), $47b1592ab1581a62$var$j(n, "table-head"), $47b1592ab1581a62$var$j(a, "table-body");
            const s = _.headers, r = $47b1592ab1581a62$var$w(s), i = o.Ue.createDocumentFragment(), l = $47b1592ab1581a62$var$E("tr");
            for (const e of r){
                const n = s[e], o = $47b1592ab1581a62$var$E("th");
                o.id = "cc__row-" + n + t, $47b1592ab1581a62$var$k(o, "scope", "col"), $47b1592ab1581a62$var$j(o, "table-th"), o.innerHTML = n, $47b1592ab1581a62$var$H(i, o);
            }
            $47b1592ab1581a62$var$H(l, i), $47b1592ab1581a62$var$H(n, l);
            const d = o.Ue.createDocumentFragment();
            for (const e of u){
                const n = $47b1592ab1581a62$var$E("tr");
                $47b1592ab1581a62$var$j(n, "table-tr");
                for (const o of r){
                    const a = s[o], r = e[o], i = $47b1592ab1581a62$var$E("td"), l = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
                    $47b1592ab1581a62$var$j(i, "table-td"), $47b1592ab1581a62$var$k(i, "data-column", a), $47b1592ab1581a62$var$k(i, "headers", "cc__row-" + a + t), l.insertAdjacentHTML("beforeend", r), $47b1592ab1581a62$var$H(i, l), $47b1592ab1581a62$var$H(n, i);
                }
                $47b1592ab1581a62$var$H(d, n);
            }
            $47b1592ab1581a62$var$H(a, d), $47b1592ab1581a62$var$H(e, n), $47b1592ab1581a62$var$H(e, a), $47b1592ab1581a62$var$H(M, e);
        }
        (S || s) && $47b1592ab1581a62$var$H(x, M);
        const L = o.Ie || o.Ge;
        b ? (V || (V = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$j(V, "section-toggles")), V.appendChild(x)) : V = null, $47b1592ab1581a62$var$H(L, V || x);
    }), C && (o.$e || (o.$e = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$j(o.$e, "btn"), $47b1592ab1581a62$var$k(o.$e, $47b1592ab1581a62$var$f, "all"), $47b1592ab1581a62$var$H(A, o.$e), $47b1592ab1581a62$var$R(o.$e, $47b1592ab1581a62$var$d, ()=>p("all"))), o.$e.innerHTML = C), S && (o.Pe || (o.Pe = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$j(o.Pe, "btn"), $47b1592ab1581a62$var$k(o.Pe, $47b1592ab1581a62$var$f, "necessary"), $47b1592ab1581a62$var$H(A, o.Pe), $47b1592ab1581a62$var$R(o.Pe, $47b1592ab1581a62$var$d, ()=>p([]))), o.Pe.innerHTML = S), x && (o.ze || (o.ze = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$j(o.ze, "btn"), $47b1592ab1581a62$var$j(o.ze, "btn--secondary"), $47b1592ab1581a62$var$k(o.ze, $47b1592ab1581a62$var$f, "save"), $47b1592ab1581a62$var$H(N, o.ze), $47b1592ab1581a62$var$R(o.ze, $47b1592ab1581a62$var$d, ()=>p())), o.ze.innerHTML = x), o.Ie && (o.we.replaceChild(o.Ie, o.Ge), o.Ge = o.Ie), $47b1592ab1581a62$var$fe(1), n.A || (n.A = !0, $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie.pe, $47b1592ab1581a62$var$u, o.we), t(e), $47b1592ab1581a62$var$H(o.qe, o.ye), setTimeout(()=>$47b1592ab1581a62$var$F(o.ye, "cc--anim"), 100)), $47b1592ab1581a62$var$X(2);
};
function $47b1592ab1581a62$var$pe(e, n, o, a, c) {
    const r = $47b1592ab1581a62$var$m.o, l = $47b1592ab1581a62$var$m.ae, f = $47b1592ab1581a62$var$E("label"), _ = $47b1592ab1581a62$var$E("input"), u = $47b1592ab1581a62$var$E("span"), p = $47b1592ab1581a62$var$E("span"), g = $47b1592ab1581a62$var$E("span"), v = $47b1592ab1581a62$var$E("span"), y = $47b1592ab1581a62$var$E("span");
    if (v.innerHTML = $47b1592ab1581a62$var$Q(1, 3), y.innerHTML = $47b1592ab1581a62$var$Q(0, 3), _.type = "checkbox", $47b1592ab1581a62$var$F(f, "section__toggle-wrapper"), $47b1592ab1581a62$var$F(_, "section__toggle"), $47b1592ab1581a62$var$F(v, "toggle__icon-on"), $47b1592ab1581a62$var$F(y, "toggle__icon-off"), $47b1592ab1581a62$var$F(u, "toggle__icon"), $47b1592ab1581a62$var$F(p, "toggle__icon-circle"), $47b1592ab1581a62$var$F(g, "toggle__label"), $47b1592ab1581a62$var$k(u, $47b1592ab1581a62$var$i, "true"), a ? ($47b1592ab1581a62$var$F(f, "toggle-service"), $47b1592ab1581a62$var$k(_, $47b1592ab1581a62$var$s, c), l.ce[c][n] = _) : l.se[n] = _, a ? ((e)=>{
        $47b1592ab1581a62$var$R(_, "change", ()=>{
            const t = l.ce[e], n = l.se[e];
            r.ee[e] = [];
            for(let n in t){
                const o = t[n];
                o.checked && r.ee[e].push(o.value);
            }
            n.checked = r.ee[e].length > 0;
        });
    })(c) : ((e)=>{
        $47b1592ab1581a62$var$R(_, $47b1592ab1581a62$var$d, ()=>{
            const t = l.ce[e], n = _.checked;
            r.ee[e] = [];
            for(let o in t)t[o].checked = n, n && r.ee[e].push(o);
        });
    })(n), _.value = n, g.textContent = e.replace(/<.*>.*<\/.*>/gm, ""), $47b1592ab1581a62$var$H(p, y), $47b1592ab1581a62$var$H(p, v), $47b1592ab1581a62$var$H(u, p), r.M) (o.readOnly || r.i.mode === $47b1592ab1581a62$var$t && o.enabled) && (_.checked = !0);
    else if (a) {
        const e = r.Z[c];
        _.checked = o.readOnly || $47b1592ab1581a62$var$b(e, n);
    } else $47b1592ab1581a62$var$b(r.O, n) && (_.checked = !0);
    return o.readOnly && (_.disabled = !0), $47b1592ab1581a62$var$H(f, _), $47b1592ab1581a62$var$H(f, u), $47b1592ab1581a62$var$H(f, g), f;
}
const $47b1592ab1581a62$var$me = ()=>{
    const e = $47b1592ab1581a62$var$E("span");
    return $47b1592ab1581a62$var$m.ae.Ke || ($47b1592ab1581a62$var$m.ae.Ke = e), e;
}, $47b1592ab1581a62$var$ge = (e, t)=>{
    const n = $47b1592ab1581a62$var$m.o, o = $47b1592ab1581a62$var$m.ae, { hide: a, showPreferences: s, acceptCategory: u } = e, p = n.u && n.u.consentModal;
    if (!p) return;
    const g = p.acceptAllBtn, b = p.acceptNecessaryBtn, v = p.showPreferencesBtn, y = p.closeIconLabel, h = p.footer, C = p.label, w = p.title, S = (e)=>{
        a(), u(e);
    };
    if (!o.ve) {
        o.ve = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.Ce = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.Qe = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.We = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.Xe = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$F(o.ve, "cm-wrapper"), $47b1592ab1581a62$var$F(o.Ce, "cm"), $47b1592ab1581a62$var$V(o.Qe, "body"), $47b1592ab1581a62$var$V(o.We, "texts"), $47b1592ab1581a62$var$V(o.Xe, "btns"), o.ve.tabIndex = -1, $47b1592ab1581a62$var$k(o.Ce, "role", "dialog"), $47b1592ab1581a62$var$k(o.Ce, "aria-modal", "true"), $47b1592ab1581a62$var$k(o.Ce, $47b1592ab1581a62$var$i, "false"), $47b1592ab1581a62$var$k(o.Ce, "aria-describedby", "cm__desc"), C ? $47b1592ab1581a62$var$k(o.Ce, "aria-label", C) : w && $47b1592ab1581a62$var$k(o.Ce, "aria-labelledby", "cm__title"), o.Ce.style.visibility = "hidden";
        const e = "box", t = n.i.guiOptions, a = t && t.consentModal, s = (a && a.layout || e).split(" ")[0] === e;
        w && y && s && (o.je || (o.je = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), o.je.innerHTML = $47b1592ab1581a62$var$Q(), $47b1592ab1581a62$var$V(o.je, "btn"), $47b1592ab1581a62$var$V(o.je, "btn--close"), $47b1592ab1581a62$var$R(o.je, $47b1592ab1581a62$var$d, ()=>{
            S([]);
        }), $47b1592ab1581a62$var$H(o.Qe, o.je)), $47b1592ab1581a62$var$k(o.je, "aria-label", y)), $47b1592ab1581a62$var$H(o.Qe, o.We), (g || b || v) && $47b1592ab1581a62$var$H(o.Qe, o.Xe), $47b1592ab1581a62$var$H(o.Ce, o.Qe), $47b1592ab1581a62$var$H(o.ve, o.Ce);
    }
    w && (o.Ye || (o.Ye = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.Ye.className = o.Ye.id = "cm__title", $47b1592ab1581a62$var$k(o.Ye, "role", "heading"), $47b1592ab1581a62$var$k(o.Ye, "aria-level", "2"), $47b1592ab1581a62$var$H(o.We, o.Ye)), o.Ye.innerHTML = w);
    let x = p.description;
    if (x && (n.H && (x = x.replace("{{revisionMessage}}", n.F ? "" : p.revisionMessage || "")), o.Ze || (o.Ze = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.Ze.className = o.Ze.id = "cm__desc", $47b1592ab1581a62$var$H(o.We, o.Ze)), o.Ze.innerHTML = x), g && (o.et || (o.et = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$H(o.et, $47b1592ab1581a62$var$me()), $47b1592ab1581a62$var$V(o.et, "btn"), $47b1592ab1581a62$var$k(o.et, $47b1592ab1581a62$var$f, "all"), $47b1592ab1581a62$var$R(o.et, $47b1592ab1581a62$var$d, ()=>{
        S("all");
    })), o.et.firstElementChild.innerHTML = g), b && (o.Ve || (o.Ve = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$H(o.Ve, $47b1592ab1581a62$var$me()), $47b1592ab1581a62$var$V(o.Ve, "btn"), $47b1592ab1581a62$var$k(o.Ve, $47b1592ab1581a62$var$f, "necessary"), $47b1592ab1581a62$var$R(o.Ve, $47b1592ab1581a62$var$d, ()=>{
        S([]);
    })), o.Ve.firstElementChild.innerHTML = b), v && (o.tt || (o.tt = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$r), $47b1592ab1581a62$var$H(o.tt, $47b1592ab1581a62$var$me()), $47b1592ab1581a62$var$V(o.tt, "btn"), $47b1592ab1581a62$var$V(o.tt, "btn--secondary"), $47b1592ab1581a62$var$k(o.tt, $47b1592ab1581a62$var$f, "show"), $47b1592ab1581a62$var$R(o.tt, "mouseenter", ()=>{
        n.A || $47b1592ab1581a62$var$ue(e, t);
    }), $47b1592ab1581a62$var$R(o.tt, $47b1592ab1581a62$var$d, s)), o.tt.firstElementChild.innerHTML = v), o.nt || (o.nt = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$V(o.nt, $47b1592ab1581a62$var$l), g && $47b1592ab1581a62$var$H(o.nt, o.et), b && $47b1592ab1581a62$var$H(o.nt, o.Ve), (g || b) && $47b1592ab1581a62$var$H(o.Qe, o.nt), $47b1592ab1581a62$var$H(o.Xe, o.nt)), o.tt && !o.ot && (o.ot = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), o.Ve && o.et ? ($47b1592ab1581a62$var$V(o.ot, $47b1592ab1581a62$var$l), $47b1592ab1581a62$var$H(o.ot, o.tt), $47b1592ab1581a62$var$H(o.Xe, o.ot)) : ($47b1592ab1581a62$var$H(o.nt, o.tt), $47b1592ab1581a62$var$V(o.nt, $47b1592ab1581a62$var$l + "--uneven"))), h) {
        if (!o.st) {
            let e = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), t = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c);
            o.st = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), $47b1592ab1581a62$var$V(e, "footer"), $47b1592ab1581a62$var$V(t, "links"), $47b1592ab1581a62$var$V(o.st, "link-group"), $47b1592ab1581a62$var$H(t, o.st), $47b1592ab1581a62$var$H(e, t), $47b1592ab1581a62$var$H(o.Ce, e);
        }
        o.st.innerHTML = h;
    }
    $47b1592ab1581a62$var$fe(0), n.D || (n.D = !0, $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie.pe, $47b1592ab1581a62$var$_, o.Ce), t(e), $47b1592ab1581a62$var$H(o.qe, o.ve), setTimeout(()=>$47b1592ab1581a62$var$F(o.ve, "cc--anim"), 100)), $47b1592ab1581a62$var$X(1), $47b1592ab1581a62$var$U(o.Qe, e, $47b1592ab1581a62$var$ue, t);
}, $47b1592ab1581a62$var$be = (e)=>$47b1592ab1581a62$var$y(e) && e in $47b1592ab1581a62$var$m.o._, $47b1592ab1581a62$var$ve = ()=>$47b1592ab1581a62$var$m.o.l || $47b1592ab1581a62$var$m.o.i.language.default, $47b1592ab1581a62$var$ye = (e)=>{
    e && ($47b1592ab1581a62$var$m.o.l = e);
}, $47b1592ab1581a62$var$he = async (e)=>{
    const t = $47b1592ab1581a62$var$m.o;
    let n = $47b1592ab1581a62$var$be(e) ? e : $47b1592ab1581a62$var$ve(), o = t._[n];
    if (!o) return !1;
    if ($47b1592ab1581a62$var$y(o)) {
        const e = await (async (e)=>{
            try {
                const t = await fetch(e);
                return !(!t || !t.ok) && await t.json();
            } catch (e) {
                return !1;
            }
        })(o);
        if (!e) return !1;
        o = e;
    }
    return t.u = o, $47b1592ab1581a62$var$ye(n), !0;
}, $47b1592ab1581a62$var$Ce = ()=>{
    let e = $47b1592ab1581a62$var$m.o.i.language.rtl, t = $47b1592ab1581a62$var$m.ae.qe;
    e && t && ($47b1592ab1581a62$var$v(e) || (e = [
        e
    ]), $47b1592ab1581a62$var$b(e, $47b1592ab1581a62$var$m.o.l) ? $47b1592ab1581a62$var$F(t, "cc--rtl") : $47b1592ab1581a62$var$P(t, "cc--rtl"));
}, $47b1592ab1581a62$var$we = ()=>{
    const e = $47b1592ab1581a62$var$m.ae;
    if (!e.qe) {
        e.qe = $47b1592ab1581a62$var$E($47b1592ab1581a62$var$c), e.qe.id = "cc-main", $47b1592ab1581a62$var$Ce();
        let t = $47b1592ab1581a62$var$m.o.i.root;
        t && $47b1592ab1581a62$var$y(t) && (t = document.querySelector(t)), (t || e.Ue.body).appendChild(e.qe);
    }
}, $47b1592ab1581a62$var$Se = (e)=>{
    const { hostname: t, protocol: n } = location, { name: o, path: a, domain: s, sameSite: c } = $47b1592ab1581a62$var$m.t.cookie, r = encodeURIComponent(JSON.stringify($47b1592ab1581a62$var$m.o.p)), i = e ? (()=>{
        const e = $47b1592ab1581a62$var$m.o.C, t = e ? new Date - e : 0;
        return 864e5 * $47b1592ab1581a62$var$B() - t;
    })() : 864e5 * $47b1592ab1581a62$var$B(), l = new Date;
    l.setTime(l.getTime() + i);
    let d = o + "=" + r + (0 !== i ? "; expires=" + l.toUTCString() : "") + "; Path=" + a + "; SameSite=" + c;
    $47b1592ab1581a62$var$b(t, ".") && (d += "; Domain=" + s), "https:" === n && (d += "; Secure"), document.cookie = d, $47b1592ab1581a62$var$m.o.p;
}, $47b1592ab1581a62$var$xe = (e, t, n)=>{
    const o = n || $47b1592ab1581a62$var$m.t.cookie.domain, a = t || $47b1592ab1581a62$var$m.t.cookie.path, s = "www." === o.slice(0, 4), c = s && o.substring(4), r = (e, t)=>{
        document.cookie = e + "=; path=" + a + (t ? "; domain=." + t : "") + "; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    };
    for (const t of e)r(t), r(t, o), s && r(t, c);
}, $47b1592ab1581a62$var$Me = (e)=>((e)=>{
        let t;
        try {
            t = JSON.parse(decodeURIComponent(e));
        } catch (e) {
            t = {};
        }
        return t;
    })($47b1592ab1581a62$var$De(e || $47b1592ab1581a62$var$m.t.cookie.name, !0)), $47b1592ab1581a62$var$De = (e, t)=>{
    const n = document.cookie.match("(^|;)\\s*" + e + "\\s*=\\s*([^;]+)");
    return n ? t ? n.pop() : e : "";
}, $47b1592ab1581a62$var$Te = (e)=>{
    const t = document.cookie.split(/;\s*/), n = [];
    for (const o of t){
        let t = o.split("=")[0];
        if (e) try {
            e.test(t) && n.push(t);
        } catch (e) {}
        else n.push(t);
    }
    return n;
}, $47b1592ab1581a62$export$f733614a75aede52 = (n, o = [])=>{
    ((e, t)=>{
        const { L: n, O: o, R: a, A: s, ee: c, Y: r } = $47b1592ab1581a62$var$m.o;
        let i = [];
        if (e) {
            $47b1592ab1581a62$var$v(e) ? i.push(...e) : $47b1592ab1581a62$var$y(e) && (i = "all" === e ? n : [
                e
            ]);
            for (const e of n)c[e] = $47b1592ab1581a62$var$b(i, e) ? $47b1592ab1581a62$var$w(r[e]) : [];
        } else i = s ? (()=>{
            const e = $47b1592ab1581a62$var$m.ae.se;
            if (!e) return [];
            let t = [];
            for(let n in e)e[n].checked && t.push(n);
            return t;
        })() : o;
        i = i.filter((e)=>!$47b1592ab1581a62$var$b(n, e) || !$47b1592ab1581a62$var$b(t, e)), i.push(...a), $47b1592ab1581a62$var$J(i);
    })(n, o), ((e)=>{
        const t = $47b1592ab1581a62$var$m.o, { ee: n, R: o, Z: a, Y: s, L: c } = t, r = c;
        t.ne = $47b1592ab1581a62$var$I(a);
        for (const e of r){
            const t = s[e], c = $47b1592ab1581a62$var$w(t), r = n[e] && n[e].length > 0, i = $47b1592ab1581a62$var$b(o, e);
            if (0 !== c.length) {
                if (a[e] = [], i) a[e].push(...c);
                else if (r) {
                    const t = n[e];
                    a[e].push(...t);
                } else a[e] = [];
                a[e] = $47b1592ab1581a62$var$S(a[e]);
            }
        }
    })(), (()=>{
        const n = $47b1592ab1581a62$var$m.o;
        $47b1592ab1581a62$var$m.t.mode === $47b1592ab1581a62$var$t && n.M ? n.V = $47b1592ab1581a62$var$G(n.B, n.O) : n.V = $47b1592ab1581a62$var$G(n.O, n.p.categories);
        let o = n.V.length > 0, a = !1;
        for (const e of n.L)n.te[e] = $47b1592ab1581a62$var$G(n.Z[e], n.ne[e]), n.te[e].length > 0 && (a = !0);
        const s = $47b1592ab1581a62$var$m.ae.se;
        for(let e in s)s[e].checked = $47b1592ab1581a62$var$b(n.O, e);
        for (const e of n.L){
            const t = $47b1592ab1581a62$var$m.ae.ce[e], o = n.Z[e];
            for(const e in t)t[e].checked = $47b1592ab1581a62$var$b(o, e);
        }
        n.h || (n.h = new Date), n.S || (n.S = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e)=>(e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16))), n.p = {
            categories: $47b1592ab1581a62$var$I(n.O),
            revision: $47b1592ab1581a62$var$m.t.revision,
            data: n.v,
            consentTimestamp: n.h.toISOString(),
            consentId: n.S,
            services: $47b1592ab1581a62$var$I(n.Z)
        };
        let c = !1;
        (n.M || o || a) && (n.M && (n.M = !1, c = !0), n.C ? n.C = new Date : n.C = n.h, n.p.lastConsentTimestamp = n.C.toISOString(), $47b1592ab1581a62$var$Se(), $47b1592ab1581a62$var$m.t.autoClearCookies && (c || !n.M && o) && ((e)=>{
            const t = $47b1592ab1581a62$var$m.o, n = $47b1592ab1581a62$var$Te();
            t.j = !1;
            let o = e ? t.L : t.V;
            o = o.filter((e)=>{
                let n = t.I[e];
                return !!n && !n.readOnly && !!n.autoClear;
            });
            for (const a of o){
                const o = t.I[a].autoClear, s = o && o.cookies || [], c = $47b1592ab1581a62$var$b(t.V, a), r = !$47b1592ab1581a62$var$b(t.O, a), i = c && r;
                if (e && r || !e && i) {
                    !0 === o.reloadPage && i && (t.j = !0);
                    for (const e of s){
                        let t = [];
                        const o = e.name, a = e.domain, s = e.path;
                        if (o instanceof RegExp) for (let e of n)o.test(e) && t.push(e);
                        else {
                            let e = $47b1592ab1581a62$var$g(n, o);
                            e > -1 && t.push(n[e]);
                        }
                        t.length > 0 && $47b1592ab1581a62$var$xe(t, s, a);
                    }
                }
            }
        })(c), $47b1592ab1581a62$var$Z()), c && ($47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie.le), $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie.de), $47b1592ab1581a62$var$m.t.mode === $47b1592ab1581a62$var$e) || ((o || a) && $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie.fe), n.j && location.reload());
    })();
}, $47b1592ab1581a62$export$d57953daf19d40f0 = (e)=>{
    const t = $47b1592ab1581a62$var$m.o.M ? [] : $47b1592ab1581a62$var$m.o.O;
    return $47b1592ab1581a62$var$b(t, e);
}, $47b1592ab1581a62$export$954bc960519baaed = (e, t)=>{
    const { L: n, Y: o } = $47b1592ab1581a62$var$m.o;
    if (!(e && t && $47b1592ab1581a62$var$y(t) && $47b1592ab1581a62$var$b(n, t) && 0 !== $47b1592ab1581a62$var$w(o[t]).length)) return !1;
    ((e, t)=>{
        const n = $47b1592ab1581a62$var$m.o, { Y: o, ee: a, A: s } = n, c = $47b1592ab1581a62$var$m.ae.ce[t] || {}, r = $47b1592ab1581a62$var$m.ae.se[t] || {}, i = $47b1592ab1581a62$var$w(o[t]);
        if (a[t] = [], $47b1592ab1581a62$var$y(e)) {
            if ("all" === e) {
                if (a[t].push(...i), s) for(let e in c)c[e].checked = !0, $47b1592ab1581a62$var$T(c[e]);
            } else if ($47b1592ab1581a62$var$b(i, e) && a[t].push(e), s) for(let t in c)c[t].checked = e === t, $47b1592ab1581a62$var$T(c[t]);
        } else if ($47b1592ab1581a62$var$v(e)) for (let n of i){
            const o = $47b1592ab1581a62$var$b(e, n);
            o && a[t].push(n), s && (c[n].checked = o, $47b1592ab1581a62$var$T(c[n]));
        }
        const l = 0 === a[t].length;
        n.O = l ? n.O.filter((e)=>e !== t) : $47b1592ab1581a62$var$S([
            ...n.O,
            t
        ]), s && (r.checked = !l, $47b1592ab1581a62$var$T(r));
    })(e, t), $47b1592ab1581a62$export$f733614a75aede52();
}, $47b1592ab1581a62$export$c6d040ca60661d88 = (e, t)=>{
    const n = $47b1592ab1581a62$var$m.o.M ? [] : $47b1592ab1581a62$var$m.o.Z[t];
    return $47b1592ab1581a62$var$b(n, e);
}, $47b1592ab1581a62$export$26b2c20fc8da53a0 = (e)=>"" !== $47b1592ab1581a62$var$De(e, !0), $47b1592ab1581a62$export$6dde6a4e31d2b3a6 = (e, t, n)=>{
    let o = [];
    const a = (e)=>{
        if ($47b1592ab1581a62$var$y(e)) {
            let t = $47b1592ab1581a62$var$De(e);
            "" !== t && o.push(t);
        } else o.push(...$47b1592ab1581a62$var$Te(e));
    };
    if ($47b1592ab1581a62$var$v(e)) for (let t of e)a(t);
    else a(e);
    $47b1592ab1581a62$var$xe(o, t, n);
}, $47b1592ab1581a62$export$57bf213be019eeb0 = (e)=>{
    const { ae: t, o: o } = $47b1592ab1581a62$var$m;
    if (!o.T) {
        if (!o.D) {
            if (!e) return;
            $47b1592ab1581a62$var$ge($47b1592ab1581a62$var$Le, $47b1592ab1581a62$var$we);
        }
        o.T = !0, o.J = $47b1592ab1581a62$var$x(), o.g && $47b1592ab1581a62$var$q(!0), $47b1592ab1581a62$var$F(t.he, $47b1592ab1581a62$var$n), $47b1592ab1581a62$var$k(t.Ce, $47b1592ab1581a62$var$i, "false"), $47b1592ab1581a62$var$$(t.ve, 1), $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie._e, $47b1592ab1581a62$var$_);
    }
}, $47b1592ab1581a62$export$fe8985bb6374093c = ()=>{
    const { ae: e, o: t, ie: o } = $47b1592ab1581a62$var$m;
    t.T && (t.T = !1, t.g && $47b1592ab1581a62$var$q(), $47b1592ab1581a62$var$$(e.Ke, !1, !0), $47b1592ab1581a62$var$P(e.he, $47b1592ab1581a62$var$n), $47b1592ab1581a62$var$k(e.Ce, $47b1592ab1581a62$var$i, "true"), $47b1592ab1581a62$var$$(t.J), t.J = null, $47b1592ab1581a62$var$Y(o.ue, $47b1592ab1581a62$var$_));
}, $47b1592ab1581a62$export$535e69674d40eb20 = ()=>{
    const e = $47b1592ab1581a62$var$m.o;
    e.k || (e.A || $47b1592ab1581a62$var$ue($47b1592ab1581a62$var$Le, $47b1592ab1581a62$var$we), e.k = !0, $47b1592ab1581a62$var$F($47b1592ab1581a62$var$m.ae.he, $47b1592ab1581a62$var$o), $47b1592ab1581a62$var$k($47b1592ab1581a62$var$m.ae.we, $47b1592ab1581a62$var$i, "false"), e.T ? e.U = $47b1592ab1581a62$var$x() : e.J = $47b1592ab1581a62$var$x(), $47b1592ab1581a62$var$$($47b1592ab1581a62$var$m.ae.ye, 2), $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie._e, $47b1592ab1581a62$var$u));
}, $47b1592ab1581a62$export$5b3a895f6cbac580 = ()=>{
    const e = $47b1592ab1581a62$var$m.o;
    e.k && (e.k = !1, (()=>{
        const e = $47b1592ab1581a62$export$3bdcc4c9b3764a39(), n = $47b1592ab1581a62$var$m.o.I, o = $47b1592ab1581a62$var$m.ae.se, a = $47b1592ab1581a62$var$m.ae.ce, s = (e)=>$47b1592ab1581a62$var$m.o.i.mode === $47b1592ab1581a62$var$t && !!n[e].enabled;
        for(const t in o){
            const c = !!n[t].readOnly;
            o[t].checked = c || (e ? $47b1592ab1581a62$export$d57953daf19d40f0(t) : s(t));
            for(const n in a[t])a[t][n].checked = c || (e ? $47b1592ab1581a62$export$c6d040ca60661d88(n, t) : s(t));
        }
    })(), $47b1592ab1581a62$var$$($47b1592ab1581a62$var$m.ae.Be, !1, !0), $47b1592ab1581a62$var$P($47b1592ab1581a62$var$m.ae.he, $47b1592ab1581a62$var$o), $47b1592ab1581a62$var$k($47b1592ab1581a62$var$m.ae.we, $47b1592ab1581a62$var$i, "true"), e.T ? ($47b1592ab1581a62$var$$(e.U, 1), e.U = null) : ($47b1592ab1581a62$var$$(e.J), e.J = null), $47b1592ab1581a62$var$Y($47b1592ab1581a62$var$m.ie.ue, $47b1592ab1581a62$var$u));
};
var $47b1592ab1581a62$var$Le = {
    show: $47b1592ab1581a62$export$57bf213be019eeb0,
    hide: $47b1592ab1581a62$export$fe8985bb6374093c,
    showPreferences: $47b1592ab1581a62$export$535e69674d40eb20,
    hidePreferences: $47b1592ab1581a62$export$5b3a895f6cbac580,
    acceptCategory: $47b1592ab1581a62$export$f733614a75aede52
};
const $47b1592ab1581a62$export$4b6bf64406ec64af = async (e, t)=>{
    if (!$47b1592ab1581a62$var$be(e)) return !1;
    const n = $47b1592ab1581a62$var$m.o;
    return !(e === $47b1592ab1581a62$var$ve() && !0 !== t || !await $47b1592ab1581a62$var$he(e) || ($47b1592ab1581a62$var$ye(e), n.D && $47b1592ab1581a62$var$ge($47b1592ab1581a62$var$Le, $47b1592ab1581a62$var$we), n.A && $47b1592ab1581a62$var$ue($47b1592ab1581a62$var$Le, $47b1592ab1581a62$var$we), $47b1592ab1581a62$var$Ce(), 0));
}, $47b1592ab1581a62$export$ae3f5fa351e2f57a = ()=>{
    const { P: e, Z: t } = $47b1592ab1581a62$var$m.o, { accepted: n, rejected: o } = (()=>{
        const { M: e, O: t, L: n } = $47b1592ab1581a62$var$m.o;
        return {
            accepted: t,
            rejected: e ? [] : n.filter((e)=>!$47b1592ab1581a62$var$b(t, e))
        };
    })();
    return $47b1592ab1581a62$var$I({
        acceptType: e,
        acceptedCategories: n,
        rejectedCategories: o,
        acceptedServices: t,
        rejectedServices: $47b1592ab1581a62$var$L()
    });
}, $47b1592ab1581a62$export$2cb99e4be0dc4646 = (e, t)=>{
    let n = document.querySelector('script[src="' + e + '"]');
    return new Promise((o)=>{
        if (n) return o(!0);
        if (n = $47b1592ab1581a62$var$E("script"), $47b1592ab1581a62$var$h(t)) for(const e in t)$47b1592ab1581a62$var$k(n, e, t[e]);
        n.onload = ()=>o(!0), n.onerror = ()=>{
            n.remove(), o(!1);
        }, n.src = e, $47b1592ab1581a62$var$H(document.head, n);
    });
}, $47b1592ab1581a62$export$3cbc67a40c3171bd = (e)=>{
    let t, n = e.value, o = e.mode, a = !1;
    const s = $47b1592ab1581a62$var$m.o;
    if ("update" === o) {
        s.v = t = $47b1592ab1581a62$export$4be65e66cfa2648a("data");
        const e = typeof t == typeof n;
        if (e && "object" == typeof t) {
            !t && (t = {});
            for(let e in n)t[e] !== n[e] && (t[e] = n[e], a = !0);
        } else !e && t || t === n || (t = n, a = !0);
    } else t = n, a = !0;
    return a && (s.v = t, s.p.data = t, $47b1592ab1581a62$var$Se(!0)), a;
}, $47b1592ab1581a62$export$4be65e66cfa2648a = (e, t)=>{
    const n = $47b1592ab1581a62$var$Me(t);
    return e ? n[e] : n;
}, $47b1592ab1581a62$export$44487a86467333c3 = (e)=>{
    const t = $47b1592ab1581a62$var$m.t, n = $47b1592ab1581a62$var$m.o.i;
    return e ? t[e] || n[e] : {
        ...t,
        ...n,
        cookie: {
            ...t.cookie
        }
    };
}, $47b1592ab1581a62$export$3bdcc4c9b3764a39 = ()=>!$47b1592ab1581a62$var$m.o.M, $47b1592ab1581a62$export$889ea624f2cb2c57 = async (e)=>{
    const { o: n, t: o, ie: a } = $47b1592ab1581a62$var$m, c = window;
    if (!c._ccRun) {
        if (c._ccRun = !0, ((e)=>{
            const { ae: n, t: o, o: a } = $47b1592ab1581a62$var$m, c = o, r = a, { cookie: i } = c, l = $47b1592ab1581a62$var$m.re, d = e.cookie, f = e.categories, _ = $47b1592ab1581a62$var$w(f) || [], u = navigator, p = document;
            n.Ue = p, n.he = p.documentElement, i.domain = location.hostname, r.i = e, r.I = f, r.L = _, r._ = e.language.translations, r.g = !!e.disablePageInteraction, l.le = e.onFirstConsent, l.de = e.onConsent, l.fe = e.onChange, l.ue = e.onModalHide, l._e = e.onModalShow, l.pe = e.onModalReady;
            const { mode: g, autoShow: v, lazyHtmlGeneration: y, autoClearCookies: C, revision: S, manageScriptTags: x, hideFromBots: M } = e;
            g === $47b1592ab1581a62$var$t && (c.mode = g), "boolean" == typeof C && (c.autoClearCookies = C), "boolean" == typeof x && (c.manageScriptTags = x), "number" == typeof S && S >= 0 && (c.revision = S, r.H = !0), "boolean" == typeof v && (c.autoShow = v), "boolean" == typeof y && (c.lazyHtmlGeneration = y), !1 === M && (c.hideFromBots = !1), !0 === c.hideFromBots && u && (r.G = u.userAgent && /bot|crawl|spider|slurp|teoma/i.test(u.userAgent) || u.webdriver), $47b1592ab1581a62$var$h(d) && (c.cookie = {
                ...i,
                ...d
            }), c.autoClearCookies, r.H, c.manageScriptTags, ((e)=>{
                const { I: t, Y: n, Z: o, ee: a, R: s } = $47b1592ab1581a62$var$m.o;
                for (let c of e){
                    const e = t[c], r = e.services || {}, i = $47b1592ab1581a62$var$h(r) && $47b1592ab1581a62$var$w(r) || [];
                    n[c] = {}, o[c] = [], a[c] = [], e.readOnly && (s.push(c), o[c] = i), $47b1592ab1581a62$var$m.ae.ce[c] = {};
                    for (let e of i){
                        const t = r[e];
                        t.Se = !1, n[c][e] = t;
                    }
                }
            })(_), (()=>{
                if (!$47b1592ab1581a62$var$m.t.manageScriptTags) return;
                const e = $47b1592ab1581a62$var$m.o, t = $47b1592ab1581a62$var$D(document, "script[" + $47b1592ab1581a62$var$s + "]");
                for (const n of t){
                    let t = $47b1592ab1581a62$var$N(n, $47b1592ab1581a62$var$s), o = n.dataset.service || "", a = !1;
                    if (t && "!" === t.charAt(0) && (t = t.slice(1), a = !0), "!" === o.charAt(0) && (o = o.slice(1), a = !0), $47b1592ab1581a62$var$b(e.L, t) && (e.oe.push({
                        Me: n,
                        xe: !1,
                        Ee: a,
                        De: t,
                        Te: o
                    }), o)) {
                        const n = e.Y[t];
                        n[o] || (n[o] = {
                            Se: !1
                        });
                    }
                }
            })(), $47b1592ab1581a62$var$ye((()=>{
                const e = $47b1592ab1581a62$var$m.o.i.language.autoDetect;
                if (e) {
                    let t;
                    if ("browser" === e ? t = navigator.language.slice(0, 2).toLowerCase() : "document" === e && (t = document.documentElement.lang), $47b1592ab1581a62$var$be(t)) return t;
                }
                return $47b1592ab1581a62$var$ve();
            })());
        })(e), n.G) return;
        (()=>{
            const e = $47b1592ab1581a62$var$m.o, n = $47b1592ab1581a62$var$m.t, o = $47b1592ab1581a62$var$Me(), { categories: a, services: s, consentId: c, consentTimestamp: r, lastConsentTimestamp: i, data: l, revision: d } = o, f = $47b1592ab1581a62$var$v(a);
            e.p = o, e.S = c;
            const _ = !!c && $47b1592ab1581a62$var$y(c);
            e.h = r, e.h && (e.h = new Date(r)), e.C = i, e.C && (e.C = new Date(i)), e.v = void 0 !== l ? l : null, e.H && _ && d !== n.revision && (e.F = !1), e.M = !(_ && e.F && e.h && e.C && f), e.M, e.M ? n.mode === $47b1592ab1581a62$var$t && ((()=>{
                const e = $47b1592ab1581a62$var$m.o;
                for (const n of e.L){
                    const o = e.I[n];
                    if (o.readOnly || o.enabled && e.i.mode === $47b1592ab1581a62$var$t) {
                        e.B.push(n);
                        const t = e.Y[n] || {};
                        for(let o in t)e.Z[n].push(o);
                    }
                }
            })(), e.O = [
                ...e.B
            ]) : (e.Z = {
                ...e.Z,
                ...s
            }, $47b1592ab1581a62$var$J([
                ...e.R,
                ...a
            ])), e.ee = {
                ...e.Z
            };
        })();
        const i = $47b1592ab1581a62$export$3bdcc4c9b3764a39();
        if (!await $47b1592ab1581a62$var$he()) return !1;
        if ($47b1592ab1581a62$var$U(null, r = $47b1592ab1581a62$var$Le, $47b1592ab1581a62$var$ue, $47b1592ab1581a62$var$we), $47b1592ab1581a62$var$m.o.M && $47b1592ab1581a62$var$ge(r, $47b1592ab1581a62$var$we), $47b1592ab1581a62$var$m.t.lazyHtmlGeneration || $47b1592ab1581a62$var$ue(r, $47b1592ab1581a62$var$we), (()=>{
            const e = $47b1592ab1581a62$var$m.ae, t = $47b1592ab1581a62$var$m.o;
            $47b1592ab1581a62$var$R(e.he, "keydown", (e)=>{
                if ("Tab" !== e.key) return;
                if (!t.k && !t.T) return;
                const n = t.W, o = t.K;
                if (n.length > 0) {
                    const t = $47b1592ab1581a62$var$x();
                    e.shiftKey ? t !== n[0] && o.contains(t) || ($47b1592ab1581a62$var$M(e), $47b1592ab1581a62$var$$(n[1])) : t !== n[1] && o.contains(t) || ($47b1592ab1581a62$var$M(e), $47b1592ab1581a62$var$$(n[0]));
                }
            }, !0);
        })(), o.autoShow && !i && $47b1592ab1581a62$export$57bf213be019eeb0(!0), i) return $47b1592ab1581a62$var$Z(), $47b1592ab1581a62$var$Y(a.de);
        o.mode === $47b1592ab1581a62$var$t && $47b1592ab1581a62$var$Z(n.B);
    }
    var r;
}, $47b1592ab1581a62$export$aad8462122ac592b = (e)=>{
    const { qe: t, he: s } = $47b1592ab1581a62$var$m.ae, { name: c, path: r, domain: i } = $47b1592ab1581a62$var$m.t.cookie;
    e && $47b1592ab1581a62$export$6dde6a4e31d2b3a6(c, r, i);
    for (const { me: e, ge: t, be: n } of $47b1592ab1581a62$var$m.o.m)e.removeEventListener(t, n);
    t && t.remove(), s && s.classList.remove($47b1592ab1581a62$var$a, $47b1592ab1581a62$var$o, $47b1592ab1581a62$var$n);
    const l = new $47b1592ab1581a62$var$p;
    for(const e in $47b1592ab1581a62$var$m)$47b1592ab1581a62$var$m[e] = l[e];
    window._ccRun = !1;
};


async function $880fab2efb2da4ab$var$getTrackers(domain) {
    return (await (await fetch("https://privacy-cms.webcloud.cloud/graphql", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            query: /* graphql */ `
            {
              policies_nolang(filter: {translations: {Domain: {_eq: "${domain}"}}}) {
                id
                services(filter: {ServicesId: {trackers: {name: {_nnull: true}}}}) {
                  ServicesId {
                    Name
                    trackers(sort: ["name"]) {
                      tracker_typology
                      name
                      pattern
                      is_pattern_regex
                      storage_duration
                      cookie_typology
                    }
                  }
                }
              }
            }
          `
        })
    })).json()).data.policies_nolang[0];
}
function $880fab2efb2da4ab$var$translateDuration(value, lang) {
    return value.replace("anni", {
        it: "anni",
        en: "years",
        de: "Jahre"
    }[lang]).replace("mesi", {
        it: "mesi",
        en: "months",
        de: "Monate"
    }[lang]).replace("giorni", {
        it: "giorni",
        en: "days",
        de: "Tage"
    }[lang]).replace("ore", {
        it: "ore",
        en: "hours",
        de: "Stunden"
    }[lang]).replace("minuti", {
        it: "minuti",
        en: "minutes",
        de: "Minuten"
    }[lang]).replace("secondi", {
        it: "secondi",
        en: "seconds",
        de: "Sekunden"
    }[lang]).replace("anno", {
        it: "anno",
        en: "year",
        de: "Jahr"
    }[lang]).replace("mese", {
        it: "mese",
        en: "month",
        de: "Monat"
    }[lang]).replace("giorno", {
        it: "giorno",
        en: "day",
        de: "Tag"
    }[lang]).replace("ora", {
        it: "ora",
        en: "hour",
        de: "Stunde"
    }[lang]).replace("minuto", {
        it: "minuto",
        en: "minute",
        de: "Minute"
    }[lang]).replace("secondo", {
        it: "secondo",
        en: "second",
        de: "Sekunde"
    }[lang]).replace("Sessione", {
        it: "Sessione",
        en: "Session",
        de: "Session"
    }[lang]);
}
function $880fab2efb2da4ab$var$includeCookieTable(trackers, typology, lang) {
    return {
        headers: {
            name: ({
                it: "Nome",
                en: "Name",
                de: "Name"
            })[lang],
            duration: ({
                it: "Durata archiviazione",
                en: "Storage duration",
                de: "Speicherdauer"
            })[lang],
            service: ({
                it: "Servizio",
                en: "Service",
                de: "Dienst"
            })[lang]
        },
        body: trackers.services.flatMap((service)=>service.ServicesId.trackers.map((tracker)=>({
                    ...tracker,
                    service: service.ServicesId.Name
                }))).filter((tracker)=>tracker.cookie_typology === typology).map((tracker)=>({
                name: tracker.name,
                duration: $880fab2efb2da4ab$var$translateDuration(tracker.storage_duration, lang),
                service: tracker.service
            }))
    };
}
function $880fab2efb2da4ab$var$includeAutoClearCookies(trackers, typology) {
    return trackers.services.flatMap((service)=>service.ServicesId.trackers).filter((tracker)=>tracker.tracker_typology === "cookie" && tracker.cookie_typology === typology).map((tracker)=>({
            name: tracker.is_pattern_regex ? new RegExp(tracker.pattern) : tracker.pattern
        }));
}
async function $880fab2efb2da4ab$var$logConsent(policyId, tcString) {
    const cookie = $47b1592ab1581a62$export$4be65e66cfa2648a();
    const preferences = $47b1592ab1581a62$export$ae3f5fa351e2f57a();
    await fetch("https://privacy-cms.webcloud.cloud/items/consents", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            client_id: cookie.consentId,
            accept_type: preferences.acceptType,
            accepted_categories: preferences.acceptedCategories,
            rejected_categories: preferences.rejectedCategories,
            url: window.location.href,
            tc_string: tcString,
            PoliciesId: policyId
        })
    });
}
//! has to fire within 1500 ms from gtag('consent', 'default', ...
function $880fab2efb2da4ab$var$toggleGtagConsent(cookieCategories) {
    if (typeof gtag !== "function") return;
    if (cookieCategories.includes("necessary")) gtag("consent", "update", {
        security_storage: $47b1592ab1581a62$export$d57953daf19d40f0("necessary") ? "granted" : "denied"
    });
    if (cookieCategories.includes("analytics")) gtag("consent", "update", {
        analytics_storage: $47b1592ab1581a62$export$d57953daf19d40f0("analytics") ? "granted" : "denied"
    });
    if (cookieCategories.includes("functionality")) gtag("consent", "update", {
        functionality_storage: $47b1592ab1581a62$export$d57953daf19d40f0("functionality") ? "granted" : "denied"
    });
    if (cookieCategories.includes("marketing")) gtag("consent", "update", {
        ad_storage: $47b1592ab1581a62$export$d57953daf19d40f0("marketing") ? "granted" : "denied",
        ad_user_data: $47b1592ab1581a62$export$d57953daf19d40f0("marketing") ? "granted" : "denied",
        ad_personalization: $47b1592ab1581a62$export$d57953daf19d40f0("marketing") ? "granted" : "denied",
        personalization_storage: $47b1592ab1581a62$export$d57953daf19d40f0("marketing") ? "granted" : "denied"
    });
}
function $880fab2efb2da4ab$var$onFirstConsentOrChange(policyId, cookieCategories, tcString) {
    $880fab2efb2da4ab$var$logConsent(policyId, tcString);
}
function $880fab2efb2da4ab$var$onConsentOrChangeInternal(privacyPolicyUrl, cookieCategories) {
    $880fab2efb2da4ab$var$toggleGtagConsent(cookieCategories);
    if ($47b1592ab1581a62$export$ae3f5fa351e2f57a().acceptType !== "all") {
        const lang = $880fab2efb2da4ab$var$getLanguageIndex();
        document.querySelectorAll("[data-wc-cc-bc]").forEach((el)=>{
            el.outerHTML = `<div data-wc-cc-bc-dg style="${window.getComputedStyle(el.parentElement).getPropertyValue("position") !== "static" ? "position:absolute;top:0;left:0;right:0;bottom:0;" : ""}background-color:#d1d1d1;display:flex;align-items:center;justify-content:center;overflow:hidden;flex-flow:column nowrap;padding:30px;"><div style="max-width:600px;display:flex;flex-flow:column nowrap;gap:30px"><div style="font-weight:700;font-size:20px;font-family:sans-serif;line-height:1.1;color:#555;text-align:center">${[
                "ATTENZIONE",
                "ATTENTION",
                "AUFMERKSAMKEIT"
            ][lang]}<div></div>${[
                "Questo contenuto \xe8 bloccato perch\xe9 non hai accettato tutti i cookie",
                "This content is blocked because you have not accepted all cookies",
                "Dieser Inhalt ist blockiert, da Sie nicht alle Cookies akzeptiert haben"
            ][lang]}.</div><div style="font-family:sans-serif;line-height:1.3;font-size:13px;color:#666">${[
                "Il nostro sito prevede funzionalit\xe0 aggiuntive non disponibili se non previa accettazione dei cookie. Puoi prendere visione della nostra",
                "Our site provides additional features that are not available unless cookies are accepted. You can view ours",
                "Unsere Website bietet zus\xe4tzliche Funktionen, die nur verf\xfcgbar sind, wenn Cookies akzeptiert werden. Sie k\xf6nnen sich unsere ansehen"
            ][lang]} <a href="${privacyPolicyUrl}" style="display:inline;cursor:pointer;text-decoration:underline;font-family:sans-serif;color:inherit;font-size:inherit" target="_blank">${[
                "informativa sulla privacy",
                "Privacy Policy",
                "Datenschutzrichtlinie"
            ][lang]}</a> ${[
                "e, se lo ritieni opportuno,",
                "and, if you deem it appropriate,",
                "und wenn Sie es f\xfcr angemessen halten,"
            ][lang]} <span onclick="wcccShowPreferences()" style="display:inline;cursor:pointer;text-decoration:underline;font-family:sans-serif;font-weight:700;color:#0051ff;font-size:inherit">${[
                "cliccare qui per modificare le preferenze cookie",
                "click here to change your cookie preferences",
                "Klicken Sie hier, um Ihre Cookie-Einstellungen zu \xe4ndern"
            ][lang]}</span>. ${[
                "Se vuoi usufruire di tutte le funzionalit\xe0 di questo sito, ti consigliamo di accettare tutti i cookie",
                "If you want to take advantage of all the features of this site, we recommend that you accept all cookies",
                "Wenn Sie alle Funktionen dieser Website nutzen m\xf6chten, empfehlen wir Ihnen, alle Cookies zu akzeptieren"
            ][lang]}.</div></div></div>` + el.outerHTML;
        });
    } else {
        document.querySelectorAll("[data-wc-cc-bc-dg]").forEach((el)=>{
            el.remove();
        });
        window.dispatchEvent(new Event("wc-cc-bc-show"));
    }
}
function $880fab2efb2da4ab$var$getLanguageIndex() {
    switch(document.documentElement.lang){
        case "it":
        case "it-IT":
            return 0;
        case "en":
        case "en-GB":
        case "en-US":
            return 1;
        case "de":
        case "de-DE":
            return 2;
        default:
            return 1;
    }
}
function $880fab2efb2da4ab$var$getTranslations(privacyPolicyUrl, trackers) {
    return {
        it: {
            consentModal: {
                title: "Informativa",
                description: `Usiamo i cookie e altre tecnologie simili per far funzionare il nostro sito. Con il tuo permesso, vorremmo usare i cookie anche per altre cose, come te lo spieghiamo nella nostra <a href="${privacyPolicyUrl}" target="_blank">informativa sulla privacy</a>. Se non sei d'accordo, puoi cliccare su 'rifiuta' per continuare senza i cookie aggiuntivi. In tal caso potresti non essere in grado di utilizzare tutte le funzionalit\xe0 del nostro sito.`,
                footer: `<a href="${privacyPolicyUrl}" target="_blank">Informativa sulla privacy</a><a onclick="wcccAcceptNecessary()" style="font-weight:normal;font-size:12px;cursor:pointer;margin-left:auto;align-self:center;">Rifiuta</a>`,
                acceptAllBtn: "Accetta",
                showPreferencesBtn: "Gestisci preferenze"
            },
            preferencesModal: {
                title: "Preferenze cookie",
                acceptAllBtn: "Accetta tutti",
                acceptNecessaryBtn: "Rifiuta tutti",
                savePreferencesBtn: "Conferma preferenze",
                closeIconLabel: "Chiudi la finestra",
                sections: [
                    {
                        description: "Qui hai la possibilit\xe0 di scegliere quali tipi di cookie accettare o rifiutare. Tieni presente che se decidi di rifiutare alcuni cookie, potresti non essere in grado di utilizzare tutte le funzionalit\xe0 del nostro sito."
                    },
                    {
                        title: 'Cookie tecnici <span class="pm__badge">Sempre attivati</span>',
                        description: "Essenziali per la navigazione del sito. Senza questi cookie, assolutamente necessari, non saremmo in grado di fornire certi servizi o funzioni e la navigazione sul sito risulterebbe poco agevole e pi\xf9 difficile di come dovrebbe essere",
                        linkedCategory: "necessary",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "necessary", "it")
                    },
                    {
                        title: "Cookie di analisi",
                        description: "Migliorano il funzionamento del sito raccogliendo informazioni sul suo utilizzo, mostrando ad esempio quali sono le pagine pi\xf9 visitate di frequente; ci agevolano anche nell\u2019individuazione di eventuali difficolt\xe0 riscontrate durante la navigazione del sito",
                        linkedCategory: "analytics",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "analytics", "it")
                    },
                    {
                        title: "Cookie di funzionalit\xe0",
                        description: "Consentono di ricordare le scelte che compi sul sito per fornirti un\u2019esperienza pi\xf9 personalizzata, ad esempio dandoti la possibilit\xe0 di scegliere cosa visualizzare in una certa pagina o mostrandoti promozioni a cui non hai gi\xe0 partecipato",
                        linkedCategory: "functionality",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "functionality", "it")
                    },
                    {
                        title: "Cookie di profilazione",
                        description: "Usati per mostrarti pubblicit\xe0 che riteniamo potresti trovare interessanti e misurare l\u2019efficacia delle nostre campagne pubblicitarie. Questi cookie ricordano cosa hai visto sul sito. Possiamo condividere queste informazioni con altri soggetti, ad esempio, gli inserzionisti pubblicitari",
                        linkedCategory: "marketing",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "marketing", "it")
                    },
                    {
                        description: `<a href="${privacyPolicyUrl}" target="_blank">Informativa sulla privacy</a>`
                    }
                ]
            }
        },
        en: {
            consentModal: {
                title: "Notice",
                description: `We use cookies and similar technologies to make our site work. With your permission, we would like to use cookies for other things, as we explain in our <a href="${privacyPolicyUrl}" target="_blank">privacy policy</a>. If you disagree, you can click on 'Reject' or close this message to continue without additional cookies. In this case, you may not be able to use all the features of our site.`,
                footer: `<a href="${privacyPolicyUrl}" target="_blank">Privacy policy</a>`,
                acceptAllBtn: "Accept",
                acceptNecessaryBtn: "Reject",
                showPreferencesBtn: "Customize",
                closeIconLabel: "Reject and close"
            },
            preferencesModal: {
                title: "Cookie preferences",
                acceptAllBtn: "Accept all",
                acceptNecessaryBtn: "Reject all",
                savePreferencesBtn: "Save preferences",
                closeIconLabel: "Close the window",
                sections: [
                    {
                        description: "Here you have the opportunity to choose which types of cookies to accept or reject. Keep in mind that if you decide to reject some cookies, you may not be able to use all the features of our site."
                    },
                    {
                        title: 'Technical Cookies <span class="pm__badge">Always activated</span>',
                        description: "Essential for site navigation. Without these absolutely necessary cookies, we would not be able to provide certain services or features and navigation on the site would be less smooth and more difficult than it should be",
                        linkedCategory: "necessary",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "necessary", "en")
                    },
                    {
                        title: "Analytics Cookies",
                        description: "Improve the operation of the site by collecting information about its use, for example showing which are the most frequently visited pages; they also facilitate us in identifying any difficulties encountered during site navigation",
                        linkedCategory: "analytics",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "analytics", "en")
                    },
                    {
                        title: "Functionality Cookies",
                        description: "Allow to remember the choices you make on the site to provide you with a more personalized experience, for example by giving you the option to choose what to display on a certain page or showing you promotions you have not already participated in",
                        linkedCategory: "functionality",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "functionality", "en")
                    },
                    {
                        title: "Profiling Cookies",
                        description: "Used to show you advertisements that we believe you might find interesting and measure the effectiveness of our advertising campaigns. These cookies remember what you have seen on the site. We may share this information with other parties, for example, advertisers",
                        linkedCategory: "marketing",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "marketing", "en")
                    },
                    {
                        description: `<a href="${privacyPolicyUrl}" target="_blank">Privacy policy</a>`
                    }
                ]
            }
        },
        de: {
            consentModal: {
                title: "Hinweis",
                description: `Wir verwenden Cookies und \xe4hnliche Technologien, um unsere Website zu betreiben. Mit Ihrer Erlaubnis m\xf6chten wir Cookies auch f\xfcr andere Dinge verwenden, wie wir in unserer <a href="${privacyPolicyUrl}" target="_blank">Datenschutzerkl\xe4rung</a> erkl\xe4ren. Wenn Sie nicht einverstanden sind, k\xf6nnen Sie auf 'Ablehnen' klicken oder diese Nachricht schlie\xdfen, um ohne zus\xe4tzliche Cookies fortzufahren. In diesem Fall k\xf6nnen Sie m\xf6glicherweise nicht alle Funktionen unserer Website nutzen.`,
                footer: `<a href="${privacyPolicyUrl}" target="_blank">Datenschutzerkl\xe4rung</a>`,
                acceptAllBtn: "Akzeptieren",
                acceptNecessaryBtn: "Ablehnen",
                showPreferencesBtn: "Anpassen",
                closeIconLabel: "Ablehnen und schlie\xdfen"
            },
            preferencesModal: {
                title: "Cookie-Einstellungen",
                acceptAllBtn: "Alles akzeptieren",
                acceptNecessaryBtn: "Alles ablehnen",
                savePreferencesBtn: "Einstellungen speichern",
                closeIconLabel: "Fenster schlie\xdfen",
                sections: [
                    {
                        description: "Hier haben Sie die M\xf6glichkeit zu w\xe4hlen, welche Arten von Cookies Sie akzeptieren oder ablehnen m\xf6chten. Bedenken Sie, dass Sie m\xf6glicherweise nicht alle Funktionen unserer Website nutzen k\xf6nnen, wenn Sie sich entscheiden, einige Cookies abzulehnen."
                    },
                    {
                        title: 'Technische Cookies <span class="pm__badge">Immer aktiviert</span>',
                        description: "Unverzichtbar f\xfcr die Navigation auf der Website. Ohne diese absolut notwendigen Cookies k\xf6nnten wir bestimmte Dienste oder Funktionen nicht anbieten und die Navigation auf der Website w\xe4re weniger reibungslos und schwieriger als sie sein sollte",
                        linkedCategory: "necessary",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "necessary", "de")
                    },
                    {
                        title: "Analyse-Cookies",
                        description: "Verbessern die Funktionsweise der Website, indem sie Informationen \xfcber ihre Nutzung sammeln, beispielsweise welche Seiten am h\xe4ufigsten besucht werden; sie helfen uns auch dabei, m\xf6gliche Schwierigkeiten bei der Navigation auf der Website zu identifizieren",
                        linkedCategory: "analytics",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "analytics", "de")
                    },
                    {
                        title: "Funktionalit\xe4ts-Cookies",
                        description: "Erm\xf6glichen es, die von Ihnen auf der Website getroffenen Auswahl zu speichern, um Ihnen ein personalisierteres Erlebnis zu bieten, beispielsweise indem Sie die M\xf6glichkeit haben, auszuw\xe4hlen, was auf einer bestimmten Seite angezeigt wird, oder indem Ihnen Werbeaktionen angezeigt werden, an denen Sie noch nicht teilgenommen haben",
                        linkedCategory: "functionality",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "functionality", "de")
                    },
                    {
                        title: "Profilierungs-Cookies",
                        description: "Wird verwendet, um Ihnen Werbung anzuzeigen, die wir f\xfcr interessant halten k\xf6nnten, und die Wirksamkeit unserer Werbekampagnen zu messen. Diese Cookies merken sich, was Sie auf der Website gesehen haben. Wir k\xf6nnen diese Informationen mit anderen Parteien teilen, z. B. mit Werbetreibenden",
                        linkedCategory: "marketing",
                        cookieTable: $880fab2efb2da4ab$var$includeCookieTable(trackers, "marketing", "de")
                    },
                    {
                        description: `<a href="${privacyPolicyUrl}" target="_blank">Datenschutzerkl\xe4rung</a>`
                    }
                ]
            }
        }
    };
}
window.wcccShowPreferences = function() {
    if (window.wcccEnableGooglefc) window?.googlefc?.showRevocationMessage && window.googlefc.showRevocationMessage();
    else $47b1592ab1581a62$export$535e69674d40eb20();
};
window.wcccAcceptNecessary = function() {
    $47b1592ab1581a62$export$f733614a75aede52([]);
    $47b1592ab1581a62$export$fe8985bb6374093c();
};
window.wccc = async function({ privacyPolicyDomain: privacyPolicyDomain, privacyPolicyUrl: privacyPolicyUrl, onConsentOrChange: onConsentOrChange, enableGooglefc: enableGooglefc }) {
    const trackers = await $880fab2efb2da4ab$var$getTrackers(privacyPolicyDomain);
    const policyId = trackers?.id;
    let tcString;
    if (!policyId) {
        console.error("No privacy policy found for this domain");
        return;
    }
    window.wcccEnableGooglefc = enableGooglefc;
    if (enableGooglefc) {
        // Make sure that the properties exist on the window.
        window.googlefc = window.googlefc || {};
        window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
        // Queue the callback using the CONSENT_API_READY key on the callbackQueue.
        window.googlefc.callbackQueue.push({
            CONSENT_API_READY: ()=>window.__tcfapi("addEventListener", 2.0, (data, success)=>{
                    if (data?.eventStatus !== "useractioncomplete" || !data.purpose?.consents) return;
                    // true = user consented to all purposes
                    const hasFullConsent = Object.entries(data.purpose.consents).every((item)=>item[1] === true || parseInt(item[0], 10) > 10);
                    tcString = data.tcString;
                    // [] = reject all (accept only categories marked as readOnly/necessary)
                    $47b1592ab1581a62$export$f733614a75aede52(hasFullConsent ? "all" : []);
                })
        });
    }
    const translations = $880fab2efb2da4ab$var$getTranslations(privacyPolicyUrl, trackers);
    $47b1592ab1581a62$export$889ea624f2cb2c57({
        autoShow: !enableGooglefc,
        onModalShow: ({ modalName: modalName })=>{
            try {
                // in case of cookie consent accepting plugins like i don't care about cookies
                // (otherwise the body cannot scroll)
                if (window.getComputedStyle(document.querySelector("#cc-main")).display === "none") // document.documentElement.classList.remove('show--consent')
                window.wcccAcceptNecessary();
            } catch (e) {}
        },
        // callback function executed once, on the user's first consent action
        onFirstConsent ({ cookie: cookie }) {
            $880fab2efb2da4ab$var$onFirstConsentOrChange(policyId, cookie.categories, tcString);
        },
        // callback function executed on the user's first consent action and after each page load
        onConsent: ({ cookie: cookie })=>{
            $880fab2efb2da4ab$var$onConsentOrChangeInternal(privacyPolicyUrl, cookie.categories);
            onConsentOrChange && onConsentOrChange(cookie.categories);
        },
        // callback function executed when the user's preferences — such as accepted categories and services — change
        onChange ({ changedCategories: changedCategories, changedPreferences: changedPreferences }) {
            $880fab2efb2da4ab$var$onFirstConsentOrChange(policyId, changedCategories, tcString);
            $880fab2efb2da4ab$var$onConsentOrChangeInternal(privacyPolicyUrl, changedCategories);
            onConsentOrChange && onConsentOrChange(changedCategories);
        },
        disablePageInteraction: true,
        guiOptions: {
            consentModal: {
                layout: "box",
                position: "middle center",
                equalWeightButtons: false,
                flipButtons: false
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                equalWeightButtons: true,
                flipButtons: false
            }
        },
        categories: {
            necessary: {
                readOnly: true,
                autoClear: {
                    cookies: $880fab2efb2da4ab$var$includeAutoClearCookies(trackers, "necessary"),
                    reloadPage: true
                }
            },
            functionality: {
                autoClear: {
                    cookies: $880fab2efb2da4ab$var$includeAutoClearCookies(trackers, "functionality"),
                    reloadPage: true
                }
            },
            analytics: {
                autoClear: {
                    cookies: $880fab2efb2da4ab$var$includeAutoClearCookies(trackers, "analytics"),
                    reloadPage: true
                }
            },
            marketing: {
                autoClear: {
                    cookies: $880fab2efb2da4ab$var$includeAutoClearCookies(trackers, "marketing"),
                    reloadPage: true
                }
            }
        },
        language: {
            default: "en",
            autoDetect: "document",
            translations: {
                "it": translations["it"],
                "it-IT": translations["it"],
                "en": translations["en"],
                "en-GB": translations["en"],
                "en-US": translations["en"],
                "de": translations["de"],
                "de-DE": translations["de"]
            }
        }
    });
};

})();
//# sourceMappingURL=wccc.js.map
